/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Searcherrorgeneric2Inputs */



/**
* | output |
* | --- |
* | "Couldn’t start the search. Try again later" |
*
* @param {Searcherrorgeneric2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const searcherrorgeneric2 = /** @type {((inputs?: Searcherrorgeneric2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Searcherrorgeneric2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Couldn’t start the search. Try again later")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo iniciar la búsqueda. Inténtalo más tarde")
	return /** @type {LocalizedString} */ ("Не получилось начать поиск. Попробуй позже")
});
export { searcherrorgeneric2 as "searchErrorGeneric" }